import { CircularProgress } from '../../CircularProgress';
import { Icon } from '../../Icon';
import { Pressed } from '../../Pressed';
import { Stack } from '../../Stack';
import { Typography } from '../../Typography';
import { FileUploadEntity } from '../types';

import { ContainerStyled } from './FileContainer.styles';

const bytesToMegaBytes = (sizeInBytes: number) =>
  Math.max(sizeInBytes / (1024 * 1024), 0.1).toFixed(1);

interface Props {
  file: FileUploadEntity;
  onRemoveFile: () => void;
}

export const FileContainer = ({ file, onRemoveFile }: Props) => (
  <ContainerStyled
    key={file.id}
    alignItems="center"
    datax="fileContainer"
    direction="row"
    justifyContent="space-between"
  >
    <Stack
      key={file.name}
      className="fileContainer-content"
      direction="row"
      spacing={28}
    >
      <Stack className="fileContainer-fileInfo" spacing={8}>
        <Typography className="fileContainer-fileName" variant="bodySemiBold">
          {file.name}
        </Typography>
        <Typography className="fileContainer-fileSize">
          {bytesToMegaBytes(file.size)} Mb
        </Typography>
      </Stack>
    </Stack>
    {file.loading ? (
      <CircularProgress size={16} />
    ) : (
      <Pressed datax="delete" onClick={onRemoveFile}>
        <Icon.Close size={16} />
      </Pressed>
    )}
  </ContainerStyled>
);
